<template>
  <div class="text-left" v-if="publication.article !== null">
    <v-row>
      <v-col>
        <h3 class="mt-15 mb-0">
          {{ $t("title.articleData") }}
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <h5>{{ $t("form.article.journal") }}</h5>
        <v-select
          outlined
          v-model="publication.article.journal"
          :label="$t('form.article.journal')"
          :items="journals"
          item-text="title"
          item-value="id"
          readonly
          :background-color="
            'journal' in articleFieldsChanged ? getFieldsChangedColor : ''
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <h5>
          {{ $t("form.article.publication_status") }}
        </h5>
        <v-select
          outlined
          v-model="publication.article.publication_status"
          :label="$t('form.article.publication_status')"
          :items="publicationStatus"
          item-value="value"
          item-text="text"
          readonly
          :background-color="
            'publication_status' in articleFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        />
      </v-col>
    </v-row>
    <h5>{{ $t("label.dates") }}</h5>
    <v-row>
      <v-col cols="12" sm="4" class="py-0">
        <v-text-field
          outlined
          v-model="publication.article.accepted_date"
          :label="$t('form.article.accepted_date')"
          prepend-inner-icon="event"
          readonly
          :background-color="
            'accepted_date' in articleFieldsChanged ? getFieldsChangedColor : ''
          "
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" class="py-0">
        <v-text-field
          outlined
          v-model="publication.article.online_publication_date"
          :label="$t('form.article.online_publication_date')"
          prepend-inner-icon="event"
          readonly
          :background-color="
            'online_publication_date' in articleFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" class="py-0">
        <v-text-field
          outlined
          v-model="publication.article.final_publication_date"
          :label="$t('form.article.final_publication_date')"
          prepend-inner-icon="event"
          readonly
          :background-color="
            'final_publication_date' in articleFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <h5 :class="'journal_location' in articleFieldsChanged ? 'amber' : ''">
      {{ $t("form.article.journal_location") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.article.journal_location.issue_number"
          :label="$t('form.article.issueNumber')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.article.journal_location.volume"
          :label="$t('form.article.volume')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.article.journal_location.page_number"
          :label="$t('form.article.pageNumber')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.article.journal_location.pages"
          :label="$t('form.article.pages')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.article.feder_acknowledgements") }}
    </h5>
    <v-row>
      <v-col>
        <v-checkbox
          class="big"
          v-model="publication.article.feder_acknowledgements"
          :label="$t('form.federAcknowledgementsDetail')"
          readonly
          :background-color="
            'feder_acknowledgements' in articleFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  name: "ReviewModifyArticle",
  mixins: [publication_model],
  props: {
    publication: Object,
    fieldsChanged: Object
  },

  created() {
    this.getPublicationStatus();
    this.getJournals();
  },

  computed: {
    articleFieldsChanged() {
      if (this.fieldsChanged.article !== undefined) {
        return this.fieldsChanged.article;
      } else {
        return {};
      }
    }
  }
};
</script>
